// src/components/WideModal.tsx
import React from "react";
import Modal from "components/Modal";

interface WideModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Variante ancha del modal. Antes era una copia completa de Modal.tsx con otro
 * `max-width` (y sin animación ni foco); ahora reutiliza el mismo panel para
 * que scrim, radio, sombra y transición sean idénticos en toda la app.
 */
const WideModal: React.FC<WideModalProps> = ({ isOpen, onClose, children }) => (
  <Modal isOpen={isOpen} onClose={onClose} size="xl">
    {children}
  </Modal>
);

export default WideModal;
